import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'

import Breadcrumb from './src/breadcrumb.vue'
import BreadcrumbItem from './src/breadcrumb-item.vue'

export const SgBreadcrumb = withInstall(Breadcrumb, {
  BreadcrumbItem,
})
export const SgBreadcrumbItem = withNoopInstall(BreadcrumbItem)
export default SgBreadcrumb

export * from './src/breadcrumb'
export * from './src/breadcrumb-item'
export * from './src/constants'
